<div class="formGroup">
    <div class="fileUpload">
        <div *ngIf="errorMessages?.length">
            <!-- fileUploadFinished__text-Klasse für Text-Wrap -->
            <div *ngFor="let msg of errorMessages" class="error-class fileUpload__text-word-break-enforced">{{msg}}</div>
        </div>
        <label *ngIf="label" [ngClass]="{'required-class': mandatory}">{{label}}</label>
        <!-- alle bereits hochgeladenen Files -->
        <div class="uploadedFileRow" *ngFor="let attachment of uploadedAttachments">
            <span *ngIf="attachment.state === 'VIRUS'" class="error-class">{{i18n.uploadError}}</span>
            <div class="fileUploadRow">
                <div class="fileUploadField" [ngClass]="{'error-class': attachment.state === 'VIRUS'}">
                    <div class="fileUploadFinished">
                        <!-- ein Block der einer Textzeile entspricht, aber komplett gebrpchen werden soll! -->
                        <div class="fileUpload__text-word-break-enforced">
                            <a href="javascript:" class="fileUploadFinished__text" (click)="download(attachment)"
                               *ngIf="attachment.state === 'NO_VIRUS'">{{attachment.name}}</a>
                            <span *ngIf="attachment.state === 'VIRUS'" class="fileUploadFinished__text">
                                {{attachment.name}}
                            </span>
                            ({{formatBytes(attachment.size)}})
                        </div>
                    </div>
                </div>
                <div class="fileUploadButtons">
                    <button type="button" ibtn="bin" ibtnUnboxed (click)="delete(attachment)"
                            [disabled]="uploadDisabled"
                            [title]="i18n.removeFile"
                    ></button>
                </div>
            </div>
        </div>
        <!-- neue Datei hochladen (Während Datei hochgeladen wird, wird das angezeigt) -->
        <div class="fileUploadRow" *ngIf="!uploadDisabled && showUpload()">
            <div class="fileUploadField">
                <div fileDrop class="fileUploadDropdown" (filesDropped)="upload($event)">
                    <span *ngIf="uploadingAttachments.length === 0">{{i18n.dropZone}}</span>
                    <div *ngFor="let uploadingAttachment of uploadingAttachments">
                        <!-- ein Block der einer Textzeile entspricht, aber komplett gebrochen werden soll! -->
                        <div class="fileUpload__text-word-break-enforced">
                            {{uploadingAttachment.name}}
                        </div>
                    </div>
                </div>
                <i class="fileUploadProgress" [ngStyle]="{'width': progress + '%'}"></i>
            </div>
            <div class="fileUploadButtons">
                <button type="button" ibtn="folder" ibtnUnboxed (click)="click()" [disabled]="uploadDisabled"
                        [title]="i18n.selectFile"
                ></button>
            </div>
        </div>
        <div class="fileUploadRow" *ngIf="!uploadDisabled">
            {{i18n.maxFileSizeText}} {{(maxFileSize >= 1 ? maxFileSize : maxFileSize * 1024) | number:'1.0-2'}} {{maxFileSize >= 1 ? 'MB' : 'KB'}}
            .
        </div>
        <div class="fileUploadRow" *ngIf="mimeTypes.length > 0 && !uploadDisabled">
            {{i18n.acceptText}} {{accept}}.
        </div>
        <input class="d-none" type="file" fileSelect
               (filesSelected)="upload($event)"
               multiple
               *ngIf="!uploadDisabled"
               [accept]="allowedFileEndings"
               #fileInput/>
    </div>
</div>
